import React, { FC, ReactElement } from "react";
import styles from "./FlowButtons.module.css";
import Colors from "ui-kit/colors";
import { useWebTranslation } from "translations";
import { Button } from "ui-kit/Button";
import Gutter from "ui-kit/Gutter";

type FlowButtonsProps = {
  next: () => void;
  disabled?: boolean;
  backButton?: boolean;
  inProgress?: boolean;
  nextTitle?: string;
  previous?: () => void;
  custom?: ReactElement;
  nextColor?: keyof typeof Colors;
  nextArrow?: boolean;
};

const FlowButtons: FC<FlowButtonsProps> = ({
  next,
  nextTitle,
  nextArrow,
  disabled,
  backButton,
  inProgress,
  previous,
  custom,
  nextColor,
}) => {
  const { t } = useWebTranslation();

  return (
    <section className={styles.buttonsWrapper}>
      <div className={styles.buttonsContainer}>
        {backButton ? (
          <div className={styles.backButton}>
            <Button
              title={t("global.back")}
              color="blue300"
              onPress={() => (previous ? previous() : window.history.back())}
            />
          </div>
        ) : null}
        <div className={styles.nextButton}>
          <Button
            testId={"nextButton"}
            variant="custom"
            title={nextTitle || t("global.next")}
            color={nextColor || "blue300"}
            loading={inProgress}
            onPress={() => next()}
            disabled={disabled}
            icon={nextArrow}
          />
          {custom && (
            <>
              <Gutter size={1} />
              {custom}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

FlowButtons.defaultProps = {
  disabled: false,
  backButton: true,
  inProgress: false,
  nextTitle: undefined,
  previous: undefined,
  custom: undefined,
  nextColor: undefined,
  nextArrow: true,
};

export default FlowButtons;
